<template>
  <section>
    <v-parallax dark :src="require(`../assets/bg.jpg`)" style="height: 80vh;">
      <v-layout align-center column justify-center>
        <h1 class="display-2 mb-3">清大學程小幫手</h1>
        <h4 class="subheading mb-3">為您尋找最適合的學分學程</h4>
        <div>
          <v-btn color="primary" :loading="loading" @click="SET_IMPORT_DIALOG(true)">匯入修課紀錄</v-btn>
          <v-btn @click="example">使用範例紀錄</v-btn>
        </div>
      </v-layout>
    </v-parallax>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { SET_IMPORT_DIALOG, SET_COURSE_LOG } from '../store/constants';
import { exampleCourseLog } from '../functions/exampleCourseLog';

export default {
  name: 'hero',
  computed: {
    ...mapGetters(['loading']),
  },
  methods: {
    ...mapActions([SET_IMPORT_DIALOG, SET_COURSE_LOG]),
    example() {
      this[SET_COURSE_LOG](exampleCourseLog);
      this.$vuetify.goTo('#course-log');
    },
  },
}
</script>